import React, { useEffect } from "react";
import "animate.css";
import "bootstrap/dist/css/bootstrap.min.css";

const PageHeader = (props) => {
	return (
		<>
			{/* {MAIN HEADING BANNER} */}
			<section className="main-banner-heading">
				<div className="container">
					<h1 className="main-heading xxl-font-level text-center mt-3 mb-3 main-heading-font dark-color wow animate__animated animate__zoomIn">
						{props.pagename}
					</h1>
				</div>
			</section>
			{/* {MAIN HEADING BANNER} */}
		</>
	);
};

export default PageHeader;
